export const getCollapsedCommentPopupId = (elementId: string) => `collapsed-comment-${elementId}`;
